<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<!-- <FormItem prop="trackName" label="充电站:" :label-width="100">
			<Select filterable placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
				<Option :value='0'>全部</Option>
				<Option v-bind:key="item.StationId" v-for="(item,itemIndex) in StationList" :value="item.StationId">
					{{item.StationName}}</Option>
			</Select>
		</FormItem> -->
		<FormItem prop="trackName">
			<Input type="text" v-model="formInline.Name" placeholder="商户名称">
			<span slot="prepend">商户名称</span>
			</Input>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">查询</Button>
		</FormItem>
		<div style="float: right;">
			<Button type="primary" @click="$emit('show','add')" v-if="hasWidgets('add')">新增商户</Button>
		</div>
	</Form>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					Name: '',
				},
			};
		},
		mounted() {

		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
		},
	}
</script>

<style>
</style>
